import React from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../../helpers/toastHelper';

import OvalPoliciesIndex from './OvalPoliciesIndex';

const WrappedOvalPoliciesIndex = props => {
  const dispatch = useDispatch();

  return <OvalPoliciesIndex {...props} showToast={showToast(dispatch)} />;
};

export default WrappedOvalPoliciesIndex;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_openscap-5.2.2-2.fm3_3.el8.noarch/usr/share/gems/gems/foreman_openscap-5.2.2/webpack/routes/OvalPolicies/OvalPoliciesIndex/index.js